import React, { useEffect, useMemo, useState } from "react";
import styles from "./LeftComp.module.scss";
import FirtsockLogo from "../assets/Images/firstock-logo.svg";
import leftcompimage from "../assets/Images/SignupIllustration.svg";
import { getTheme } from "../ThemeProvider/ThemeProvider";

const LeftComp = () => {
  const getSystemTheme = () =>
    window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";
  const [mode, setMode] = useState(getSystemTheme());

  useEffect(() => {
    setMode(getSystemTheme());
  }, [getSystemTheme]);


  

  return (
    <div className={styles.mainWrapper}>
      <div className={styles.companyLogo}>
        <img
          src={FirtsockLogo}
          style={{
            zIndex: 100,
            cursor: "pointer",
            // filter:
            //   mode === "dark" ? "grayscale(0.9) invert(0.9) brightness(1)" : "",
          }}
          onClick={() => {}}
          className={styles.Logo}
        />
      </div>
      <div className={styles.centerContainer}>
        <div className={styles.imageContainer}>
          <img src={leftcompimage} alt="" className={styles.centerImage} />
        </div>
      </div>

      <div className={styles.sidebarFooter}>
        <div className={styles.textContent}>
          <div className={styles.title}>Where smart trading begins.</div>
          <div className={styles.desc}>
            Experience seamless trading with powerful tools, real-time insights,
            and a platform designed for performance.
          </div>
        </div>
        <div className={styles.footerLinks}>
          {/* <div
            className={styles.footerItem}
            onClick={() => {
              handleLogout();
            }}
          >
            Logout{" "}
          </div> */}
          <div className={styles.footerItem}>FAQ </div>
          <div
            className={styles.footerItem}
            onClick={() => {
              window.open("https://firstock.in/support/", "_blank");
            }}
          >
            Support{" "}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeftComp;
